import ContactCompleted from './ContactCompleted'

export default ContactCompleted
